let smoother = null;

export function setSmoother(instance) {
  smoother = instance;
}

export function getSmoother() {
  return smoother;
}
